import ApiUrl from "./ApiUrl";

export const LoginService = (data) => {
   // login
   const service = `${ApiUrl}user/login`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const RegisterService = (data) => {
   // login
   const service = `${ApiUrl}user/register`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const RecoverPasswordService = (data) => {
   // login
   const service = `${ApiUrl}user/recover_password`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ProfileService = (data) => {
   // perfil de usuario de la sesión
   const service = `${ApiUrl}user/profile`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const UpdateProfileService = (data) => {
   // perfil de usuario de la sesión
   const service = `${ApiUrl}user/update`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const ListUserService = () => {
   // lista de todos los usuarios
   const service = `${ApiUrl}user/list_users`;
   // const data = {token: localStorage.getItem("domecq_token")};
   return fetch(service);
};

export const DeactivateUser = (data) => {
   // desactivar a un usuaro
   const service = `${ApiUrl}user/disable_user`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const ForgotPasswordService = (data) => {
   const service = `${ApiUrl}user/recover_password`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ConfirmUserService = (data) => {
   const service = `${ApiUrl}user/user_confirm`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ChangePasswordServie = (data) => {
   // change_password
   const service = `${ApiUrl}user/change_password`;
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
